import script from "./CabinetView.vue?vue&type=script&setup=true&lang=js"
export * from "./CabinetView.vue?vue&type=script&setup=true&lang=js"

import "./CabinetView.vue?vue&type=style&index=0&id=71735034&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71735034"]])

export default __exports__